// import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useI18qualitiesModule } from "../../../../../hooks";

import { Container, SimpleCard } from "../../../../../components";
import { SectionTitle } from "../../../../../components/ui/SectionTitle/SectionTitle";

import { Section } from "../../../../../components/common/Section/Section.styled";
import { Item, List } from "./QualitiesModule.styled";

export const QualitiesModule = () => {
  const { t } = useTranslation();

  // const qualitiesData = useMemo(
  //   () => t("qualitiesModule", { returnObjects: true }),
  //   [t],
  // );

  const { qualitiesData } = useI18qualitiesModule();

  return (
    <Section variant="qualities">
      <SectionTitle title={t("global.whyMyTitle")} />

      <Container>
        <List>
          {Array.isArray(qualitiesData) &&
            qualitiesData.map((item, index) => (
              <Item key={index}>
                <SimpleCard
                  {...item}
                  index={index}
                  changesize={+true}
                  changepadding={+true}
                />
              </Item>
            ))}
        </List>
      </Container>
    </Section>
  );
};
